import React from 'react';
import { AlertTriangle, CheckCircle, Clock, XCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const IncidentStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Incidents',
      value: stats?.total || 0,
      icon: AlertTriangle,
      color: 'bg-blue-100 text-blue-600'
    },
    {
      label: 'Open',
      value: stats?.byStatus?.open || 0,
      icon: XCircle,
      color: 'bg-red-100 text-red-600'
    },
    {
      label: 'Acknowledged',
      value: stats?.byStatus?.acknowledged || 0,
      icon: Clock,
      color: 'bg-yellow-100 text-yellow-600'
    },
    {
      label: 'Resolved',
      value: stats?.byStatus?.resolved || 0,
      icon: CheckCircle,
      color: 'bg-green-100 text-green-600'
    }
  ];

  const severityStats = [
    { label: 'Critical', value: stats?.bySeverity?.critical || 0, color: 'bg-red-500' },
    { label: 'High', value: stats?.bySeverity?.high || 0, color: 'bg-orange-500' },
    { label: 'Medium', value: stats?.bySeverity?.medium || 0, color: 'bg-yellow-500' },
    { label: 'Low', value: stats?.bySeverity?.low || 0, color: 'bg-blue-500' }
  ];

  return (
    <div className="mb-6 space-y-6">
      {/* Status Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {statCards?.map((stat) => {
          const Icon = stat?.icon;
          return (
            <div key={stat?.label} className="bg-white rounded-lg shadow-sm p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat?.label}</p>
                  <p className="text-3xl font-bold text-gray-900 mt-2">{stat?.value}</p>
                </div>
                <div className={`p-3 rounded-lg ${stat?.color}`}>
                  <Icon className="w-6 h-6" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* Severity Breakdown */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Incidents by Severity</h3>
        <div className="grid grid-cols-4 gap-4">
          {severityStats?.map((severity) => (
            <div key={severity?.label} className="text-center">
              <div className={`${severity?.color} text-white rounded-lg p-4 mb-2`}>
                <p className="text-2xl font-bold">{severity?.value}</p>
              </div>
              <p className="text-sm font-medium text-gray-600">{severity?.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IncidentStats;